<div class="d-flex flex-column mt-1">
  <h4 class="text-center mb-2">
    {{ "VARIETY_CLEANING.ANSWER_DETAILS" | translate }}
  </h4>

  <div class="d-flex flex-column px-3" style="overflow-y: auto">
    <div
      class="rounded p-2 mb-2 shadow-2"
      [ngClass]="
        item.disabled ? 'disabled' : item.cleaned ? 'cleaned' : 'bg-white'
      "
      *ngFor="let item of answerInfo.list; index as i"
    >
      <span>{{ item.name }}</span>
      <hr class="my-2" />
      <h6 class="pb-2">
        {{ "OT_CLEANING.QUANTITY" | translate }}:
        {{ item.quantity + " " + item.measure }}
      </h6>
      <div class="d-flex justify-content-around">
        <span
          class="text-decoration-underline pointer"
          (click)="openHistory(item.refID)"
        >
          {{ "OT_CLEANING.HISTORY" | translate }}
        </span>
        <span
          class="text-decoration-underline pointer"
          (click)="openEditInfo(item.quantity, item.measure, item.refID)"
          *ngIf="!item.disabled"
        >
          {{ "OT_CLEANING.EDIT" | translate }}
        </span>
      </div>
    </div>
    <hr class="my-2" />
    <div class="d-flex flex-column mb-2" *ngFor="let item of answerInfo.list">
      <span>
        <strong> {{ "OT_CLEANING.UNIQUE_ID" | translate }}: </strong>
        {{ item.uuid }}
      </span>
      <span>
        <strong> {{ "OT_CLEANING.TABLET_ID" | translate }}: </strong>
        {{ item.tabletID }}
      </span>
      <span
        ><strong>{{ "OT_CLEANING.TOS" | translate }}:</strong>
        {{ item.typeOfSource }}</span
      >
      <span>
        <strong>{{ "OT_CLEANING.TOM" | translate }}:</strong>
        {{ item.reproductiveMaterial }}
      </span>
      <span>
        <strong>{{ "OT_CLEANING.QUANTITY" | translate }}:</strong>
        {{ item.quantity + " " + item.measureLang }}
      </span>
      <span>
        <strong>
          {{ item.purchased }}
        </strong>
      </span>
      <span *ngIf="item.constraints">
        <strong>{{ "OT_CLEANING.CONSTRAINTS" | translate }}:</strong>
        {{ item.constraints }}
      </span>
      <span *ngIf="item.notes"
        ><strong>{{ "OT_CLEANING.NOTES" | translate }}:</strong>
        {{ item.notes }}</span
      >
      <div
        class="btn btn-danger mb-4 ms-auto"
        *ngIf="!item.disabled"
        (click)="openDisableAnswer(item.refID, item.urlDisable, item.disabled)"
      >
        {{ "BUTTONS.DISABLE" | translate }}
      </div>
      <div
        class="btn btn-success mb-4 ms-auto"
        *ngIf="item.disabled"
        (click)="openDisableAnswer(item.refID, item.urlDisable, item.disabled)"
      >
        {{ "BUTTONS.ENABLE" | translate }}
      </div>
    </div>
  </div>
</div>
